import { AppLogo } from '@/assets/icons/AppLogo';
import { Button } from '@/components/ui/Button';

import { EditorBubbleItem } from './editor-bubble-item';

interface EditorAskSelectionButtonProps {
  onAskSelection: (selection: { text: string }) => void;
}

export function EditorAskSelectionButton({
  onAskSelection,
}: EditorAskSelectionButtonProps) {
  return (
    <EditorBubbleItem
      onSelect={(editor) => {
        const { empty, from, to } = editor.state.selection;
        if (empty) return;

        const text = editor.state.doc.textBetween(from, to, '\n\n');
        if (!text.trim()) return;
        onAskSelection({ text });
      }}
    >
      <Button
        size="xs"
        variant="ghost"
        iconSize="sm"
        className="h-6 px-1.5 hover:bg-surface-active [&>span]:gap-1.5"
        onMouseDown={(event) => event.preventDefault()}
      >
        <AppLogo className="shrink-0" />
        <span className="whitespace-nowrap text-sm">Ask about this</span>
      </Button>
    </EditorBubbleItem>
  );
}
